export const EntitySelectorEntity = Object.freeze({
	Deal: 'deal',
	Resource: 'resource',
	ResourceType: 'resource-type',
});
